import { css } from 'styled-components';

const fontM = css`
  font: var(--font-medium);
  letter-spacing: 0.02em;
`;

export { fontM };
